export const MODULE_TREE = [
  { id: 'JobTemplateDetails', label: 'Job Template Details', parent: '' },
  { id: 'Activities', label: 'Activities', parent: '' },
];

export const TABS_DATA = [
  { id: 'JobTemplateDetails', label: 'Job Template Details', parent: '' },
  { id: 'Activities', label: 'Activities', parent: '' },
];
